import { mapMutations } from 'vuex'
import store from '@/store'

export default {
	created() { 
		const resizeEvt =
		  'orientationchange' in window ? 'orientationchange' : 'resize'
		const resetRecalc = () => {
		  const __clientWidth =
		    document.documentElement.clientWidth || document.body.clientWidth

		  if (__clientWidth < 1024) {
				store.commit('SET_ISPC', false);   
		  } else {
				store.commit('SET_ISPC', true);
		  }
		}
		window.addEventListener(resizeEvt, resetRecalc.bind(this), false)
		window.addEventListener('load', resetRecalc.bind(this), false)
	},
	methods: {
		...mapMutations(['SET_ISPC']), 
	} 
}
